import { useEffect, useState } from "react"
import i18n from "@/i18n"
import {
  describeGenerationPhase,
  type GenerationJobTelemetry,
  type GenerationPhaseTranslate,
} from "@/lib/generation-phase"
import { cn } from "@/lib/utils"

const translatePhase: GenerationPhaseTranslate = (key, options) => i18n.t(`jobs:phase.${key}` as never, options)

/** Текущая фаза генерации человеческим языком; относительные времена тикают раз в секунду. */
export function GenerationPhaseLine({
  telemetry,
  className,
}: {
  telemetry: GenerationJobTelemetry | null | undefined
  className?: string
}) {
  const [now, setNow] = useState(() => Date.now())
  const active = Boolean(telemetry?.phase)

  useEffect(() => {
    if (!active) return
    const id = window.setInterval(() => setNow(Date.now()), 1000)
    return () => window.clearInterval(id)
  }, [active])

  const line = describeGenerationPhase(telemetry, now, translatePhase)
  if (!line) return null

  return (
    <p
      className={cn(
        "text-[10px]",
        telemetry?.phase === "stalled" ? "text-ui-status-rendering" : "text-ui-text-secondary",
        className,
      )}
    >
      {line}
    </p>
  )
}
